import { Close } from "@/components/Icons/utility/Close.tsx";
import { useLegalModalStore } from "@/components/LegalModal/store/useLegalModalStore.ts";
import Modal from "@/components/Modal/Modal.tsx";
import Markdown from "react-markdown";
import { useShallow } from "zustand/react/shallow";

export const LegalModal = () => {
  const { open, content, handleCloseModal } = useLegalModalStore(
    useShallow((state) => ({
      open: state.open,
      content: state.content,
      handleCloseModal: state.handleCloseModal,
    })),
  );

  return (
    <Modal isOpen={open} onClose={handleCloseModal}>
      <div className="c-legal-modal-wrapper">
        <div className="c-legal-modal-wrapper__close">
          <button className="c-close-button" onClick={handleCloseModal}>
            <Close />
          </button>
        </div>
        <div className="c-legal-modal-content u-rte">
          <Markdown>{content}</Markdown>
        </div>
      </div>
    </Modal>
  );
};
